import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const MySwal = withReactContent(Swal)

export function missingInfoAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information that is provided is not correct. Please check again. Thank you.",
  })
}

export function missingProvideBasicDocumentAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide document for proof of maid. Thank you.",
  })
}

export function missingProvideDocumentProofOfClaimAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide document for proof of claim. Thank you.",
  })
}

export function missingProvidePoliceReport() {
  MySwal.fire({
    icon: "warning",
    title: "Notice",
    text: "Please provide police report for vandalism. Thank you.",
  })
}

export function missingProvideBenefitDocumentAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide required supporting document. Thank you.",
  })
}

export function policyValidationAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Policy Number / Policyholder's name / Date of Employment does not match our records. Please check again. Thank you.",
  })
}

export function largeUploadedFile() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Large file size is detected, we will automatically compress the file, and this may take a few minutes to complete. We appreciate your patience.",
  })
}

export function errorWhenUpload() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Error while processing, kindly delete and reupload the file. Thank you.",
  })
}

export function fillAllItemAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for lost items. Please check again. Thank you.",
  })
}

export function pleaseAgreeAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please agree with the Terms & Conditions to proceed. Thank you.",
  })
}

export function pleaseCheckInfoAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information that is provided is not correct or the date is unreasonable. Please check again. Thank you.",
  })
}

export function missingDescriptionOfDamage() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide description of damage. Thank you.",
  })
}

const RemoveBenefitWarning = Swal.mixin({
  customClass: {
    confirmButton: "swal-button--yes",
    cancelButton: "swal-button--no",
    actions: "swal-footer",
  },
  buttonsStyling: false,
})

export const removeBenefitAlert = () => {
  //console.log("removeBenefitAlert fire")
  RemoveBenefitWarning.fire({
    title: "Do you want to remove this claim?",
    icon: "warning",
    scrollbarPadding: false,
    showCancelButton: true,
    confirmButtonColor: "#ff3333",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes, I do",
    cancelButtonText: "No, I don’t",
    focusConfirm: false,
  }).then(result => {
    if (result.value) {
      return true
    }
    return false
  })
}

export function windscreenPolicyValidationAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Policy Number / Policyholder's name / Vehicle Number does not match our records. Please check again. Thank you.",
  })
}

export function windscreenPolicyWithoutVehicleNoValidationAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Policy Number / Policyholder's name does not match our records. Please check again. Thank you.",
  })
}

export function notAllowedClaimAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Windscreen claim not allowed for Private Motorcycle and Commercial Motorcycle. Thank you.",
  })
}

export function accidentDateWithinPolicyPeriodAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Accident date must within policy period. Please check again. Thank you.",
  })
}
